import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-include-details-checkboxes',
    templateUrl: './include-details-checkboxes.component.html'
})
export class IncludeDetailsCheckboxesComponent {

    @Input() candidateInformationList: any[] = [];
    @Input() selectAll: boolean = false;
    @Input() title: string = '';
    @Input() checkboxPrefix: string = 'candidate';
    @Input() selectedProp: string = 'selected';
    @Input() isNotesContext: boolean = false;

    @Output() selectAllToggle = new EventEmitter<boolean>();
    @Output() candidateToggle = new EventEmitter<any>();

    onSelectAllChange(event: Event): void {
        this.selectAllToggle.emit((event.target as HTMLInputElement).checked);
    }

    onCandidateChange(candidate: any, event: Event): void {
        candidate[this.selectedProp] = (event.target as HTMLInputElement).checked;
        this.candidateToggle.emit(candidate);
    }
}
